import { useEffect, useState, useRef } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getQuoteList, createTransaction } from "store/actions";
import ButtonLoader from "Component/Common/ButtonLoader.js";
import PaymentModal from "./payment-model";
import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";
import Select from "react-select";

import { paymentMethods, platforms } from "./uniramp.js";
import { FormGroup, Label } from "reactstrap";
import useToastr from "helpers/toastr";

const UnirampComponent = ({
  cryptoValue,
  currencyValue,
  selectedCrypto,
  fields,
  isBuy,
}) => {
  const [showPymentModal, setShowPymentModal] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState();
  let symbol = selectedCurrency?.symbol;
  const { loading, AUDLoading } = useSelector((state) => state?.UniRamp);
  const iframeRef = useRef();
  const { t } = useTranslation();

  const toastr = useToastr();

  const dispatch = useDispatch();

  const [selectedWallet, setSelectedWallet] = useState();

  const { currencyList } = useSelector((state) => state?.Currency);

  const [selectedPayMethod, setSelectedPayMethod] = useState();

  const [unirampQuoteList, setUnirampQuoteList] = useState([]);
  const [paymentUrl, setPaymentUrl] = useState("");
  const [isBuyClicked, setBuyClicked] = useState(false);

  useEffect(() => {
    if (currencyList?.resdata?.length > 0) {
      setSelectedCurrency(currencyList?.resdata[0]);
      symbol = currencyList?.resdata[0]?.symbol;
    }
  }, [currencyList]);

  useEffect(() => {
    setSelectedPayMethod("");
    setSelectedWallet("");
    setUnirampQuoteList([]);
  }, [currencyValue, cryptoValue, selectedCrypto, selectedCurrency]);

  /**
   * Used for getting the currency and crypto listing
   */

  /**
   * Used for open the model of uniramp with selected platform
   */

  const buyCrypto = (e) => {
    e.preventDefault();

    if (!selectedPayMethod) {
      return toastr.error(t("select_payment_method"));
    }
    if (!selectedWallet) {
      return toastr.error(t("select_platform"));
    }
    if (fields.termsCondition == false && fields.privacyPolicy == false) {
      toastr.error(t("agree_privacy_policy"));
      toastr.error(t("agree_terms_conditions"));
      return;
    }

    if (fields.termsCondition == false) {
      toastr.error(t("agree_terms_conditions"));
      return;
    }

    if (fields.privacyPolicy == false) {
      toastr.error(t("agree_privacy_policy"));
      return;
    }

    setBuyClicked(true);
    const callback = (response) => {
      if (response?.statusCode == 200) {
        // setPaymentUrl(response?.data?.cefiInitiate?.url);
        window.open(response?.data?.cefiInitiate?.url)
        // setShowPymentModal(true);
      } else {
      } 
      setBuyClicked(false);
    };
    let data = {
      cefiGateway: selectedWallet?.gateway,
      fiat: selectedCurrency?.symbol,
      fiatAmount: currencyValue.toString(),
      payment: selectedPayMethod?.value,
      chain:
        selectedCrypto?.type == "token"
          ? selectedCrypto?.chain
          : selectedCrypto?.mainnet_symbol,
      crypto: selectedCrypto?._id,
    };
    if (selectedCrypto?.type == "token") {
      data.tokenAddress = selectedCrypto?.tokenAddress;
    }
    dispatch(createTransaction(data, callback));
  };

  const handleValueChange = (obj) => {
    const callback = (response) => {
      if (response?.statusCode == 200) {
        let data = response.data;
        let filteredPlatform = [];
        if (data.length > 0) {
          filteredPlatform = platforms
            .map((obj) => {
              const mergeArr = data.find(
                (item1) => item1.gateway === obj.value
              );
              if (mergeArr) {
                return { ...obj, ...mergeArr };
              }
              return null;
            })
            .filter((itm) => itm !== null);
          setUnirampQuoteList(filteredPlatform);
        }
      } else {
        console.log(response);
        toastr.error(response?.message);
      }
    };
    console.log("selectedCrypto", selectedCrypto);
    let data = {
      fiat: selectedCurrency?.symbol,
      fiatAmount: currencyValue.toString(),
      payment: obj?.value,
      chain:
        selectedCrypto?.type == "token"
          ? selectedCrypto?.chain
          : selectedCrypto?.mainnet_symbol,
    };
    if (selectedCrypto?.type == "token") {
      data.crypto = selectedCrypto?.tokenAddress;
    }
    dispatch(getQuoteList(data, callback));

    setSelectedPayMethod(obj);
    setSelectedWallet("");
    setUnirampQuoteList([]);
  };

  const handleWallet = (obj) => {
    setSelectedWallet(obj);
  };

  /**
   * Used for render the UI of Uniramp module page
   */

  return (
    <>
      {paymentUrl && (
        <PaymentModal
          show={showPymentModal}
          onHide={() => setShowPymentModal(!showPymentModal)}
          paymentUrl={paymentUrl}
          iframeRef={iframeRef}
        />
      )}
      <Col md={12} className="mt-3">
        <FormGroup>
          <Label for="formrow-firstname-Input">{t("payment_method")}</Label>
          <Select
            value={selectedPayMethod}
            options={paymentMethods}
            onChange={handleValueChange}
            placeholder=""
            formatOptionLabel={(obj) => (
              <div className="transsac_with_icon d-flex justify-content-between align-items-center">
                <div className="trasack_icon me-2">
                  <img src={obj?.image} alt="" className="img-fluid" />
                </div>
                <p className="m-0">{obj?.label}</p>
              </div>
            )}
          />
        </FormGroup>
      </Col>

      <Row>
        <div className="d-flex align-items-center justify-content-center">
          {AUDLoading && <ButtonLoader />}
        </div>

        {unirampQuoteList &&
          unirampQuoteList.length > 0 &&
          unirampQuoteList.map((obj, key) => (
            <Col lg={6} md={6} sm={12} className="my-4">
              <div
                onClick={() => handleWallet(obj)}
                className={
                  selectedWallet?.value == obj.value
                    ? "transack after_check py-3 px-3 pt-4 position-relative"
                    : "transack py-3 px-3 pt-4  position-relative"
                }
              >
                <div className="check">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill={
                        selectedWallet?.value == obj.value ? "green" : "#ccc"
                      }
                      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2zm4.2 8.3l-4.8 4.8c-.4.4-1 .4-1.4 0l-2.2-2.2c-.4-.4-.4-1 0-1.4c.4-.4 1-.4 1.4 0l1.5 1.5l4.1-4.1c.4-.4 1-.4 1.4 0c.4.4.4 1 0 1.4z"
                    />
                  </svg>
                </div>
                <div className="transsac_with_icon d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="trasack_icon me-2">
                      <img src={obj?.image} alt="" className="img-fluid" />
                    </div>
                    <p className="m-0">{obj?.label}</p>
                  </div>
                  <div className="transaction_value">
                    <h4>{obj?.transactionFee} </h4>
                  </div>
                </div>

                <ul className=" p-0 m-0 buy_page_list mt-2">
                  <li>
                    <p>{t("rate")}</p>
                    <p>{obj?.rate}</p>
                  </li>
                  <li>
                    <p>{t("crypto_decimal")}</p>
                    <p>{obj?.cryptoDecimal}</p>
                  </li>
                  <li>
                    <p>{t("network_fee")}</p>
                    <p>{obj?.networkFee}</p>
                  </li>
                  <li>
                    <p>{t("crypto_amount")}</p>
                    <p>{obj?.cryptoAmount}</p>
                  </li>
                </ul>
              </div>
            </Col>
          ))}
      </Row>

      <Col lg={12}>
        <div className="wallet_Address mt-4">
          <Button
            className="btn_sign_in w-100 btn_theme"
            // onClick={() => setbuycryptomodone(true)}
            disabled={
              isBuyClicked ||
              ((currencyValue == "" || cryptoValue == "") && true)
            }
            onClick={buyCrypto}
          >
            {isBuy ? t("buy") : t("sell")}
            {" " + cryptoValue + " " + selectedCrypto?.mainnet_symbol}
          </Button>
        </div>
      </Col>
      <div className="bottom_circle"></div>
    </>
  );
};

export default UnirampComponent;
